import React from "react";
import { Package, Truck, Train, Plane, Ship, Calendar, Clock, Weight, IndianRupee, ArrowRight } from "lucide-react";
import { PartnerBadges, VerifiedBadgeIcon } from "@/components/PartnerBadges";

const transportIcons = {
  road: Truck,
  rail: Train,
  air: Plane,
  water: Ship,
};

const transportColors = {
  road: "bg-orange-500",
  rail: "bg-emerald-500",
  air: "bg-blue-500",
  water: "bg-cyan-500",
};

export function CargoHeader({ listing }) {
  const Icon = transportIcons[listing.transport_mode] || Package;
  const bgColor = transportColors[listing.transport_mode] || "bg-gray-500";

  return (
    <div className="border border-border p-6">
      <div className="flex items-start justify-between mb-4">
        <div className={`w-14 h-14 ${bgColor} flex items-center justify-center`}>
          <Icon className="w-7 h-7 text-white" />
        </div>
        <span className="px-3 py-1 text-xs font-bold uppercase tracking-wider bg-emerald-500/10 text-emerald-600 border border-emerald-500/20">
          {listing.status}
        </span>
      </div>
      
      <div className="flex items-center gap-3 text-2xl font-black mb-2">
        <span>{listing.origin_city}</span>
        <ArrowRight className="w-6 h-6 text-muted-foreground" />
        <span>{listing.destination_city}</span>
      </div>
      
      <div className="flex items-center gap-2 text-muted-foreground mb-3">
        <span>Listed by <strong>{listing.partner_name}</strong></span>
        {listing.partner_verified && <VerifiedBadgeIcon className="w-5 h-5" />}
      </div>
      
      {listing.partner_badges?.length > 0 && (
        <PartnerBadges badges={listing.partner_badges} size="sm" maxShow={4} />
      )}
    </div>
  );
}

export function CargoDetailsGrid({ listing }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-border border border-border">
      <DetailCard icon={Calendar} label="Departure Date" value={listing.departure_date} />
      <DetailCard icon={Clock} label="Departure Time" value={listing.departure_time} />
      <DetailCard icon={Weight} label="Available Space" value={`${listing.available_capacity} kg`} />
      <DetailCard icon={IndianRupee} label="Price per kg" value={listing.price_per_kg} />
    </div>
  );
}

function DetailCard({ icon: Icon, label, value }) {
  return (
    <div className="bg-background p-4">
      <div className="flex items-center gap-2 text-muted-foreground text-sm mb-1">
        <Icon className="w-4 h-4" />
        <span>{label}</span>
      </div>
      <p className="font-bold">{value}</p>
    </div>
  );
}
